import Vue from 'vue'
import { LayoutPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../assets/scss/bootstrap/main.scss'

Vue.use(LayoutPlugin)
